<template>
  <div class="app">
    <t-navbar
      :nav-items="this.$getPrimaryNavItems('sales')"
      :user="authUser"
      v-model="closed"
    ></t-navbar>
    <div class="app-content">
      <main>
        <b-container fluid="lg">
          <t-header
            :user="authUser"
            :user-links="userLinks"
            :product-links="productLinks"
          />
          <router-view />
        </b-container>
      </main>
      <t-footer
        class="footer-image-bg"
        :version="appVersion"
        :logo="footerLogo"
        :nameservers="nameservers"
      />
      <t-modal />
      <t-toast />
      <t-alert />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { version } from "../../package";
import {
  PRODUCTS_ICON,
  PRODUCTS_TITLE,
  PRODUCTS_DESCRIPTION,
} from "@/constants";

import TNavbar from "@/components/TNavbar";
import TModal from "@/components/TModal";

export default {
  components: {
    TNavbar,
    TModal,
  },
  data() {
    return {
      appVersion: version,
      initialCustomer: null,
      userAccountList: null,
      closed: false,
      loading: true,
      nameservers: [],
      productLinks: [
        {
          title: PRODUCTS_TITLE.WEB,
          link: "#",
          active: true,
          icon: PRODUCTS_ICON.WEB,
          description: this.$t(PRODUCTS_DESCRIPTION.WEB),
          versionName: "- Errigal",
        },
      ],
      userLinks: [
        {
          title: this.$t("Security"),
          link: "/profile/security",
          icon: "gear",
        },
        {
          title: this.$t("Support"),
          link: "https://webtitancloud.freshdesk.com/support/home",
          icon: "life-preserver",
        },
        {
          title: this.$t("Contact"),
          link: "mailto:helpdesk@webtitan.com",
          icon: "chat-left",
        },
      ],
      footerLogo:
        this.$userPrefs.getCurrentUi().logo ||
        require("@/assets/branding/titanhq-logo.svg"),
    };
  },
  computed: {
    ...mapGetters("authentication", ["authUser"]),
    ...mapGetters("users", ["userAccounts"]),
    ...mapGetters("userInterface", ["interface"]),
  },
  watch: {},
  methods: {
    ...mapActions("authentication", ["setUser"]),
    ...mapActions("userInterface", ["fetchInterfaceBatch"]),
    toggleNavigation() {
      this.closed = !this.closed;
    },
    onWindowResize(matchMedia) {
      if (matchMedia.matches && this.closed !== true) {
        this.closed = true;
      }

      if (!matchMedia.matches && this.closed !== false) {
        this.closed = false;
      }
    },
  },
  beforeCreate() {
    const userToken = this.$userPrefs.getCurrentToken();
    if (!userToken) this.$router.push("/");
    this.$http.setAuthorisationToken(userToken);
  },
  beforeMount() {},
  async created() {
    this.loading = false;

    await this.fetchInterfaceBatch();
    //this.nameservers = this.interface.nameservers;
  },
};
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  height: 100vh;
  overflow: hidden;

  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    footer {
      margin-top: auto;
    }
  }

  .app-content {
    background-color: $bg-light;
  }
}

@media only screen and (max-width: 1200px) {
  .app {
    &-content {
      margin-left: 3.5rem;
    }
  }
}
</style>
